import React from "react";
import { FormGroup } from "react-bootstrap";
import is from "is";
import { cloneDeep } from "@utils/lodash";
import Utils from "@utils";
import { JurisdictionService } from "@services";
import axios from "axios";
import { ReactSelect, Modal } from "../../../components";

let cancelJurisdictions;

const initialState = {
	settings: {},
	showSearchForm: false,
	loading: false,
	searchResults: [],
	jurisdictionId: null,
};

class SearchJurisdictionModal extends React.PureComponent {
	constructor(props) {
		super(props);
		this.state = initialState;
	}

	handleOnConfirm = event => {
		const { lang } = global;
		if (event) {
			event.preventDefault();
		}

		if (!this.validateForm()) {
			this.setState({ feedBack: lang.t("You need to select a jurisdiction") });
			return;
		}

		this.setState(
			{
				searchResults: [],
				showSearchForm: false,
			},
			this.performCallback,
		);
	};

	performCallback = () => {
		const { settings, jurisdictionId } = this.state;

		settings.actionCallback(jurisdictionId);
	};

	validateForm = () => {
		const { jurisdictionId } = this.state;
		return !is.empty(jurisdictionId);
	};

	handleOnCancel = event => {
		if (event) {
			event.preventDefault();
		}
		const { settings } = this.state;

		if (settings.onCancel) {
			settings.onCancel();
		}

		this.setState(initialState);
	};

	openModal = settings => {
		const state = cloneDeep(this.state);

		state.settings = settings;
		state.showSearchForm = true;

		this.setState(state);
	};

	updateData = (data, loading) => {
		this.setState({
			searchResults: data,
			loading,
		});
	};

	handleOnChange = selectedOption => {
		const value = !is.null(selectedOption) ? selectedOption.value : "";

		this.setState({
			jurisdictionId: value,
		});
	};

	handleOnInputChange = searchInput => {
		const { lang } = global;
		if (!searchInput) {
			return;
		}

		this.updateData([], true);

		// If there is a currentRequest going on
		// abort it to start a new one
		if (cancelJurisdictions) {
			cancelJurisdictions();
		}

		// Save currentRequest to be able to abort it if user starts another one
		JurisdictionService.getAll({
			scope: "Name",
			search: searchInput,
			getCancelToken: c => {
				cancelJurisdictions = c;
			},
		})
			.then(response => {
				cancelJurisdictions = undefined;

				const options = response.data.map(option => ({
					value: option.Id,
					label: `${option.Name}, ${option.County} County ${option.StateName}`,
				}));

				this.updateData(options, false);
			})
			.catch(error => {
				if (!axios.isCancel(error)) {
					Utils.notify({
						type: "error",
						message: lang.t("Error loading jurisdictions"),
						title: "Oops",
					});

					this.updateData([], false);
				}
			});
	};

	render() {
		const { lang } = global;
		const { settings, showSearchForm, loading, searchResults, jurisdictionId } = this.state;

		return (
			<div>
				<Modal
					className="search-jurisdiction-modal"
					show={showSearchForm}
					onHide={this.handleOnCancel}
				>
					<Modal.Header closeButton>
						<Modal.Title>{settings.title}</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<p>{settings.text}</p>
						<div className="search-area">
							<FormGroup>
								<div>Search Jurisdiction</div>
								<ReactSelect
									name="search-jurisdiction"
									value={jurisdictionId}
									onChange={this.handleOnChange}
									onInputChange={this.handleOnInputChange}
									options={searchResults}
									isLoading={loading}
									isClearable
								/>
							</FormGroup>
						</div>
					</Modal.Body>
					<Modal.Footer>
						<button
							type="button"
							id="search-jurisdiction-confirm"
							className="btn btn-primary btn-big"
							onClick={this.handleOnConfirm}
						>
							{settings.confirmationButton || lang.t("Confirm")}
						</button>
						<button
							type="button"
							id="search-jurisdiction-cancel"
							className="btn btn-link"
							onClick={this.handleOnCancel}
						>
							{lang.t("Cancel")}
						</button>
					</Modal.Footer>
				</Modal>
			</div>
		);
	}
}

export default SearchJurisdictionModal;
